'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  height: ', ';\n  width: ', ';\n  position: fixed;\n  z-index: 1200;\n  top: ', ';\n  ', '\n  background-color: ', ';\n  box-shadow: 12px 0px 40px -14px ', ';\n  overflow-x: hidden;\n  transition: 0.5s;\n'], ['\n  height: ', ';\n  width: ', ';\n  position: fixed;\n  z-index: 1200;\n  top: ', ';\n  ', '\n  background-color: ', ';\n  box-shadow: 12px 0px 40px -14px ', ';\n  overflow-x: hidden;\n  transition: 0.5s;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  cursor: pointer;\n'], ['\n  cursor: pointer;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: auto;\n  height: 3em;\n  padding: 0 1em;\n  margin: 1em 0;\n  border-bottom: 1px ', ' solid;\n  display: flex;\n  justify-content: space-between;\n'], ['\n  width: auto;\n  height: 3em;\n  padding: 0 1em;\n  margin: 1em 0;\n  border-bottom: 1px ', ' solid;\n  display: flex;\n  justify-content: space-between;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: 100%;\n  padding: 2em;\n  height: auto;\n'], ['\n  width: 100%;\n  padding: 2em;\n  height: auto;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-weight: 400;\n  letter-spacing: 0.25em;\n  font-size: 13px;\n  text-transform: uppercase;\n'], ['\n  color: ', ';\n  font-weight: 400;\n  letter-spacing: 0.25em;\n  font-size: 13px;\n  text-transform: uppercase;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n'], ['\n  display: flex;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  width: auto;\n  display: flex;\n  margin-right: 2em;\n'], ['\n  width: auto;\n  display: flex;\n  margin-right: 2em;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  width: auto;\n'], ['\n  width: auto;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  top: ', ';\n  left: 0px;\n  opacity: 0.4;\n  ', '\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  will-change: opacity;\n  transform: translateZ(0px);\n  transition: left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  z-index: 1200;\n  pointer-events: auto;\n'], ['\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  top: ', ';\n  left: 0px;\n  opacity: 0.4;\n  ', '\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  will-change: opacity;\n  transform: translateZ(0px);\n  transition: left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  z-index: 1200;\n  pointer-events: auto;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../color');

var _color2 = _interopRequireDefault(_color);

var _MozartIcon = require('./../MozartIcon');

var _MozartIcon2 = _interopRequireDefault(_MozartIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SideNav = _styledComponents2.default.div(_templateObject, function (props) {
  return props.height;
}, function (props) {
  return props.style.width;
}, function (props) {
  return props.topValue;
}, function (props) {
  return props.position === 'left' ? "left: 0 !important;" : "right: 0 !important;";
}, _color2.default.white, _color2.default.t4);

var SideNavNode = _styledComponents2.default.div(_templateObject2);

var SideNavHeader = _styledComponents2.default.div(_templateObject3, _color2.default.blue_accent);

var SideNavBody = _styledComponents2.default.div(_templateObject4);

var SideNavHeaderLabel = _styledComponents2.default.div(_templateObject5, _color2.default.blue_main);

var SideNavHeaderNavContainer = _styledComponents2.default.div(_templateObject6);

var SideNavHeaderNav = _styledComponents2.default.div(_templateObject7);

var SideNavHeaderClose = _styledComponents2.default.div(_templateObject8);

var OverLay = _styledComponents2.default.div(_templateObject9, function (props) {
  return props.topValue;
}, function (props) {
  return props.showRelayBackgroundColor ? "background-color: " + _color2.default.blue_main : "";
});

var MozartDrawer = function (_Component) {
  _inherits(MozartDrawer, _Component);

  function MozartDrawer(props) {
    _classCallCheck(this, MozartDrawer);

    var _this = _possibleConstructorReturn(this, (MozartDrawer.__proto__ || Object.getPrototypeOf(MozartDrawer)).call(this, props));

    _this.state = {
      open: false,
      width: '0px'
    };
    return _this;
  }

  _createClass(MozartDrawer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.open && !this.props.open) {
        this.openNav();
      }
      if (!nextProps.open && this.props.open) {
        this.closeNav();
      }
    }
  }, {
    key: 'createStyle',
    value: function createStyle() {
      this.setState({
        style: _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: '\n        body { overflow: hidden !important; }\n      ' } })
      });
    }
  }, {
    key: 'deleteStyle',
    value: function deleteStyle() {
      this.setState({
        style: ''
      });
    }
  }, {
    key: 'openNav',
    value: function openNav() {
      var _this2 = this;

      var width = this.props.width;

      this.setState({ open: true, width: width }, function () {
        _this2.createStyle();
        if (_this2.props.handleOpen) {
          _this2.props.handleOpen();
        }
      });
    }
  }, {
    key: 'closeNav',
    value: function closeNav() {
      var _this3 = this;

      this.setState({ open: false, width: '0px' }, function () {
        _this3.deleteStyle();
        if (_this3.props.handleClose) {
          _this3.props.handleClose();
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          bodyStyle = _props.bodyStyle,
          node = _props.node,
          title = _props.title,
          data = _props.data,
          navData = _props.navData,
          themeId = _props.themeId,
          showHeader = _props.showHeader,
          position = _props.position,
          topValue = _props.topValue,
          height = _props.height,
          showRelayBackgroundColor = _props.showRelayBackgroundColor;

      var containerStyle = this.state.width === '0px' ? { width: this.state.width, overflow: 'hidden' } : { width: this.state.width };
      return _react2.default.createElement(
        'div',
        { style: style, 'data-qa': this.props.testId, 'data-theme': themeId },
        this.state.open && _react2.default.createElement(OverLay, { 'data-theme': 'MozartOverlay', onClick: this.closeNav.bind(this), topValue: topValue, showRelayBackgroundColor: showRelayBackgroundColor }),
        _react2.default.createElement(
          SideNav,
          { 'data-theme': 'MozartDrawer-Wrapper', style: containerStyle, position: position, topValue: topValue, height: height },
          showHeader && _react2.default.createElement(
            SideNavHeader,
            { 'data-theme': 'MozartDrawer-Header' },
            _react2.default.createElement(
              SideNavHeaderLabel,
              { 'data-theme': 'MozartDrawer-HeaderLabel' },
              title.toUpperCase ? title.toUpperCase() : title
            ),
            _react2.default.createElement(
              SideNavHeaderNavContainer,
              { 'data-theme': 'MozartDrawer-HeaderNavContainer' },
              navData && _react2.default.createElement(
                SideNavHeaderNav,
                { 'data-theme': 'MozartDrawer-HeaderNav' },
                navData
              ),
              _react2.default.createElement(
                SideNavHeaderClose,
                { 'data-theme': 'MozartDrawer-HeaderClose' },
                _react2.default.createElement(_MozartIcon2.default, { onClick: this.closeNav.bind(this), data: _react2.default.createElement('span', { className: 'icon-Close' }) })
              )
            )
          ),
          _react2.default.createElement(
            SideNavBody,
            { 'data-theme': 'MozartDrawer-Body', style: bodyStyle },
            data
          )
        ),
        _react2.default.createElement(
          SideNavNode,
          { 'data-theme': 'MozartDrawer-Node', onClick: this.openNav.bind(this) },
          node
        ),
        this.state.style
      );
    }
  }]);

  return MozartDrawer;
}(_react.Component);

MozartDrawer.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** style override */
  style: _propTypes2.default.object,
  /** body style override */
  bodyStyle: _propTypes2.default.object,
  /** default width of the drawer */
  width: _propTypes2.default.string,
  /** element used to trigger open/close drawer */
  node: _propTypes2.default.node.isRequired,
  /** title of the drawer */
  title: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  /** content could be string or node */
  data: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  /** navigation buttons next to close button, array of node */
  navData: _propTypes2.default.array,
  /** callback when opened */
  handleOpen: _propTypes2.default.func,
  /** callback when closed */
  handleClose: _propTypes2.default.func,
  /** open drawer manually */
  open: _propTypes2.default.bool,
  /** overlay color */
  overlayColor: _propTypes2.default.string,
  /** left or right*/
  position: _propTypes2.default.string,
  /** hide or show header*/
  showHeader: _propTypes2.default.bool,
  /** top value position*/
  topValue: _propTypes2.default.string,
  /** default height of the drawer */
  height: _propTypes2.default.string,
  /**realy background color*/
  showRelayBackgroundColor: _propTypes2.default.string
};
MozartDrawer.defaultProps = {
  width: '850px',
  open: false,
  testId: 'MozartDrawer',
  themeId: 'MozartDrawer',
  overlayColor: _color2.default.blue_main,
  showHeader: true,
  position: 'right',
  topValue: 0,
  height: '100%',
  showRelayBackgroundColor: true
};
exports.default = MozartDrawer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartDrawer/MozartDrawer.js
// module id = 725
// module chunks = 1